import React, { ReactChild, useEffect } from 'react';

import { FormikValues } from 'formik';

import LinearProgress from '@mui/material/LinearProgress';

import { ITask } from '../../../../state/types';
import { fetchTask, stopFetchingTask } from '../../../../state/_actions';
import { showTaskModificationDialog } from '../../../../state/ui/dialog';
import { useTaskFetching } from '../../../../state/app/fetching/selectors/index.hooks';

import { useAppDispatch, useToolkitDispatch } from '../../../../hooks';

import TranslationHelper from '../../../../helpers/TranslationHelper';

import PaneHeader from '../../../../components/PaneHeader';

import TaskHeader from '../../../../features/TaskForm/components/TaskHeader';
import TaskPreviewRightControls from '../../../../features/TaskForm/components/TaskPrevivewRightControls';
import { ISourceSet } from '../../../../state/types';

interface IOwnProps {
    task: ITask | undefined;
    pane: { elementId: string | null; elementCollectionName: string } | null;
    onClose: () => void;
    rightControls: () => ReactChild;
    handleChangeMode: () => void;
    refetchGridsData: () => void;
    handleAddLocation: (values: FormikValues) => void;
    usePlanningMode?: boolean;
    sourceSet?: ISourceSet | null;
    addActionHandler?: any;
    reportChildren: ReactChild;
}

const TaskPreview = ({
    pane,
    task,
    onClose,
    rightControls,
    handleChangeMode,
    refetchGridsData,
    handleAddLocation,
    sourceSet,
    usePlanningMode = false,
    reportChildren,
}: IOwnProps) => {
    const dispatch = useAppDispatch();

    const taskDetails = task?._meta.header.task || null;
    const taskIcon = task?._meta.header.icon || null;
    const toolkitDispatch = useToolkitDispatch();
    const taskFetchingStatus = useTaskFetching().status;

    useEffect(() => {
        if (pane) {
            handleFetchTask();
        }
        return () => {
            if (pane?.elementId) {
                dispatch(
                    stopFetchingTask(
                        pane.elementId,
                        pane?.elementCollectionName || ''
                    )
                );
            }
        };
    }, [usePlanningMode ? pane?.elementId : undefined]);

    const copyTask = () => {
        toolkitDispatch(
            showTaskModificationDialog({
                onSuccess: refetchGridsData,
                handleAddLocation,
                mode: 'copy',
                taskId: taskDetails?.id,
            })
        );
    };

    const renderRightCustomControls = () => {
        const props: any = {
            task,
            handleChangeMode,
            rightControls,
            copyTask,
        };

        if (sourceSet !== undefined) {
            props.sourceSet = sourceSet;
        }

        return <TaskPreviewRightControls {...props} />;
    };

    const handleFetchTask = () => {
        pane?.elementId && dispatch(fetchTask(pane?.elementId));
    };

    return (
        <>
            <PaneHeader
                title={TranslationHelper.translate('Task')}
                onCloseClick={onClose}
                renderRightCustomControls={renderRightCustomControls}
            />
            {taskFetchingStatus === 'loading' && !task ? (
                <LinearProgress />
            ) : (
                <>
                    <TaskHeader taskDetails={taskDetails} taskIcon={taskIcon} />
                    {reportChildren}
                </>
            )}
        </>
    );
};

export default TaskPreview;
